
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/hooks/useAuth';
import { LanguageProvider } from '@/hooks/useLanguage';

// Pages
import Index from '@/pages/Index';
import Auth from '@/pages/Auth';
import Settings from '@/pages/Settings';
import Subscriptions from '@/pages/Subscriptions';
import SubscriptionDetail from '@/pages/SubscriptionDetail';
import NewSubscription from '@/pages/NewSubscription';
import EditSubscription from '@/pages/EditSubscription';
import Invoices from '@/pages/Invoices';
import NotFound from '@/pages/NotFound';
import Customers from '@/pages/Customers';
import Services from '@/pages/Services';

// Create a client for React Query with optimized configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 0,
      refetchOnWindowFocus: false, // Prevent refetching when window gains focus
      refetchOnMount: 'always', // Only fetch when needed
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LanguageProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/auth/callback" element={<Auth />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/subscriptions" element={<Subscriptions />} />
              <Route path="/subscriptions/new" element={<NewSubscription />} />
              <Route path="/subscriptions/:id" element={<SubscriptionDetail />} />
              <Route path="/subscriptions/:id/edit" element={<EditSubscription />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/services" element={<Services />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<Navigate to="/404" />} />
            </Routes>
          </Router>
          <Toaster />
        </LanguageProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
